const adminRoutes: any = {
    path: '/a',
    name: 'company-admin',
    meta: { title: 'navigation.company-admin' },
    component: () => import('@/views/User/views/Admin/views/Index.vue'),
    redirect: { name: 'admin.projects' },
    children: [
        {
            path: 'p',
            meta: { title: "navigation['admin.projects']" },
            name: 'admin.projects',
            component: () => import('@/views/User/views/Admin/views/Projects.vue'),
        },
        {
            path: 'a',
            meta: { title: "navigation['admin.admins']" },
            name: 'admin.admins',
            component: () => import('@/views/User/views/Admin/views/Admins.vue'),
        },
        {
            path: 'e',
            meta: { title: "navigation['admin.employees']" },
            name: 'admin.employees',
            component: () => import('@/views/User/views/Admin/views/Employees.vue'),
        },
        {
            path: 'pu',
            meta: { title: "navigation['admin.projectsUsers']" },
            name: 'admin.projectsUsers',
            component: () => import('@/views/User/views/Admin/views/ProjectUsers.vue'),
        },
        {
            path: 'cr',
            meta: { title: "navigation['admin.cardReaders']" },
            name: 'manage_card_readers',
            component: () => import('@/views/User/views/Admin/views/CardReaders/CardReaders.vue'),
        },
        {
            path: 'u',
            name: 'manage_users',
            component: () => import('@/views/User/views/Admin/views/User.vue'),
            meta: {
                title: 'navigation.manage_users',
            },
        },
    ],
}

export default adminRoutes
